import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'mp-foreground-masonry-prerender',
})
export class MpForegroundMasonryPrerender {


  @Prop() index!: number;
  @Prop() collections!: any[];
  @Prop() status: 'published' | 'draft' | 'archived' = 'published';


  private item: any = {};
  private bricks: any[] = [];


  async componentWillLoad() {

    this.item = this.collections?.[this.index]?.item;

    if (!this.item) return;

    this.bricks = [];
    if (this.item.bricks) {
      for (let i=0, l=this.item.bricks.length; i<l; i++) {
        const brick = this.item.bricks[i];

        if (brick.status != 'published' || this.status != 'published') continue;

        this.bricks.push(brick);
      }
    }

    //console.log(this.bricks);
  }


  render() {

    if (!this.item) return null;

    return (
      <Host>
        {this.bricks.map((brick) => {

          let data = brick.translations[0];
          if (!data) data = {};


          return (
            <div>
              {!(!data.headline) && <h3>{data.headline}</h3>}
              {!(!data.copy) && <div class="mp-foreground-masonry-brick-copy" innerHTML={data.copy} />}
              {!(!data.download_file) && <a
                href={`https://admin.mammo-programm.de/assets/${data.download_file.id}`}
                aria-label={data.label ? data.label : null}
              >{data.download_text}</a>}
            </div>
          )

        })}
      </Host>
    )
  }
}